
import { useTheme } from '@mui/material/styles';
import { createMakeAndWithStyles } from 'tss-react';
import { DandDTheme } from '../DandDPalette';

export const { makeStyles, withStyles } = createMakeAndWithStyles({
  useTheme: useTheme as (() => DandDTheme),
  /*
    OR, if you have extended the default mui theme adding your own custom properties:
    Let's assume the myTheme object that you provide to the <ThemeProvider /> is of
    type MyTheme then you'll write:
    */
  //"useTheme": useTheme as (()=> MyTheme)
});